import { inject, Injectable } from '@angular/core';
import {
  QueryRiskMapByLegalEntityIdAndCampaignIdGQL,
  UpdateRiskMapByIdsGQL,
  QueryRiskMapByLegalEntityIdAndCampaignIdQuery,
  QueryRiskRelevanceByLegalEntityIdAndCampaignIdGQL,
  QueryRiskParametersGQL,
  QueryRiskRelevanceByLegalEntityIdAndCampaignIdQuery,
  QueryRiskMapFullByLegalEntityIdAndCampaignIdGQL,
  QueryRiskMapFullByLegalEntityIdAndCampaignIdQuery,
  CreateRiskMapMutation,
  CreateRiskMapGQL,
  CreateRiskMapByCptsGQL,
  CreateRiskMapByCptsMutation,
  UpdateRiskMapByIdsMutation,
  UpdateRiskMapEvaluationGQL,
  UpdateRiskMapStatusGQL,
  RiskMapStatusEnum,
  UpdateRiskMapStatusMutation,
  RiskMapByProcessGQL,
  RiskMapByProcessQuery,
  UpdateProcessEvaluationGQL,
  SetAuGQL,
  SetAuMutation,
  UpdateEvaluationRiskMutation,
  UpdateEvaluationRiskGQL,
  QueryriskMapRiskViewByCampaignIdAndRiskIdQuery,
  OrderTypeInput,
  ComparatorOperators,
  LegalEntityFields,
  LegalEntitySimpleQueryInput,
  OperatorInput,
  QueryLegalEntitiesByQueryComplexArgs,
  CptQueryComplexInput,
  CptCatalogueSortInput,
  QueryRiskOverallByLegalEntityIdAndCampaignIdGQL,
  QueryEvaluationOverallByLegalEntityIdAndCampaignIdGQL,
  QueryEvaluationOverallByLegalEntityIdAndCampaignIdQuery,
  QueryRiskOverallByLegalEntityIdAndCampaignIdQuery,
  UpdateProcessNoteMutation,
  UpdateProcessNoteGQL
} from '../../../graphql/generated';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RiskmapService {
  private readonly QueryRiskMapByLegalEntityIdAndCampaignIdGQL: QueryRiskMapByLegalEntityIdAndCampaignIdGQL = inject(QueryRiskMapByLegalEntityIdAndCampaignIdGQL);
  private readonly QueryRiskOverallByLegalEntityIdAndCampaignIdGQL: QueryRiskOverallByLegalEntityIdAndCampaignIdGQL = inject(QueryRiskOverallByLegalEntityIdAndCampaignIdGQL);
  private readonly QueryEvaluationOverallByLegalEntityIdAndCampaignIdGQL: QueryEvaluationOverallByLegalEntityIdAndCampaignIdGQL = inject(QueryEvaluationOverallByLegalEntityIdAndCampaignIdGQL);
  private readonly QueryRiskMapFullByLegalEntityIdAndCampaignIdGQL: QueryRiskMapFullByLegalEntityIdAndCampaignIdGQL = inject(QueryRiskMapFullByLegalEntityIdAndCampaignIdGQL);
  private readonly QueryRiskRelevanceByLegalEntityIdAndCampaignIdGQL: QueryRiskRelevanceByLegalEntityIdAndCampaignIdGQL = inject(QueryRiskRelevanceByLegalEntityIdAndCampaignIdGQL);
  private readonly QueryRiskParametersGQL: QueryRiskParametersGQL = inject(QueryRiskParametersGQL);
  private readonly CreateRiskMapGQL: CreateRiskMapGQL = inject(CreateRiskMapGQL);
  private readonly CreateRiskMapByCptsGQL: CreateRiskMapByCptsGQL = inject(CreateRiskMapByCptsGQL);
  private readonly UpdateRiskMapByIdsGQL: UpdateRiskMapByIdsGQL = inject(UpdateRiskMapByIdsGQL);
  private readonly UpdateRiskMapEvaluationGQL: UpdateRiskMapEvaluationGQL = inject(UpdateRiskMapEvaluationGQL);
  private readonly UpdateRiskMapStatusGQL: UpdateRiskMapStatusGQL = inject(UpdateRiskMapStatusGQL);
  private readonly RiskMapByProcessGQL: RiskMapByProcessGQL = inject(RiskMapByProcessGQL);
  private readonly UpdateProcessEvaluationGQL: UpdateProcessEvaluationGQL = inject(UpdateProcessEvaluationGQL);
  private readonly SetAuGQL: SetAuGQL = inject(SetAuGQL);
  private readonly UpdateProcessNoteGQL: UpdateProcessNoteGQL = inject(UpdateProcessNoteGQL)
  private readonly UpdateEvaluationRiskGQL: UpdateEvaluationRiskGQL = inject(UpdateEvaluationRiskGQL)


  getRiskmapByEntityAndYear(legalEntityId: string, campaignId: string, parameters: any): Observable<QueryRiskMapByLegalEntityIdAndCampaignIdQuery['riskEvaluationByLegalEntityIdAndCampaignId']> {
    const param = convertLazyLoadToComplexWithoutPage(parameters);
    return this.QueryRiskMapByLegalEntityIdAndCampaignIdGQL.fetch({ legalEntityId, campaignId, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.riskEvaluationByLegalEntityIdAndCampaignId));
  }
  getProcessOverall(legalEntityId: string, campaignId: string, parameters: any): Observable<QueryEvaluationOverallByLegalEntityIdAndCampaignIdQuery['riskEvaluationProcessOverallByLegalEntityIdAndCampaignId']> {
    const param = convertLazyLoadToComplexWithoutPage(parameters);
    return this.QueryEvaluationOverallByLegalEntityIdAndCampaignIdGQL.fetch({ legalEntityId, campaignId, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.riskEvaluationProcessOverallByLegalEntityIdAndCampaignId));
  }
  getRiskOverall(legalEntityId: string, campaignId: string, parameters: any): Observable<QueryRiskOverallByLegalEntityIdAndCampaignIdQuery['riskEvaluationRiskOverallByLegalEntityIdAndCampaignId']> {
    const param = convertLazyLoadToComplexWithoutPage(parameters);
    return this.QueryRiskOverallByLegalEntityIdAndCampaignIdGQL.fetch({ legalEntityId, campaignId, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.riskEvaluationRiskOverallByLegalEntityIdAndCampaignId));
  }
  getRiskmapByProcess(cptIds: string[], campaignId: string, level: number, parameters: any): Observable<RiskMapByProcessQuery['riskMapCptViewByCampaignIdAndCptIdsAndLevel']> {
    const param = convertLazyLoadToComplexWithoutPage(parameters);
    return this.RiskMapByProcessGQL.watch({ cptIds, campaignId, level, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, {
      fetchPolicy: 'no-cache'
    }).valueChanges.pipe(map(result => result.data.riskMapCptViewByCampaignIdAndCptIdsAndLevel));
  }
  getEvaluationByProcess(cptIds: string[], campaignId: string, level: number, parameters: any): void {
    // noop
    // const param = convertLazyLoadToComplexWithoutPage(parameters);
    // return this.EvaluationByProcessGQL.watch({ cptIds, campaignId, level, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, {
    //   fetchPolicy: 'no-cache',
    // }).valueChanges.pipe(map(result => result.data.riskMapCptEvaluationViewByCampaignIdAndCptIdsAndLevel));
  }

  getRiskmapFullByEntityAndYear(legalEntityId: string, campaignId: string, parameters: any): Observable<QueryRiskMapFullByLegalEntityIdAndCampaignIdQuery['riskMapByLegalEntityIdAndCampaignId']> {
    const param = convertLazyLoadToComplexWithoutPage(parameters);
    return this.QueryRiskMapFullByLegalEntityIdAndCampaignIdGQL.watch({ legalEntityId, campaignId, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, {
      fetchPolicy: 'no-cache'
    }).valueChanges.pipe(map(result => result.data.riskMapByLegalEntityIdAndCampaignId));
  }
  getRiskParameters() {
    return this.QueryRiskParametersGQL.watch({}, {
      fetchPolicy: 'no-cache'
    }).valueChanges.pipe(map(result => result.data.riskParameters));
  }

  getRiskRelevanceByEntityAndCampaign(legalEntityId: string, campaignId: string, parameters: any): Observable<QueryRiskRelevanceByLegalEntityIdAndCampaignIdQuery['riskRelevanceByLegalEntityIdAndCampaignId']> {
    const param = convertLazyLoadToComplexWithoutPage(parameters);
    return this.QueryRiskRelevanceByLegalEntityIdAndCampaignIdGQL.watch({ legalEntityId, campaignId, query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput }, {
      fetchPolicy: 'no-cache'
    }).valueChanges.pipe(map(result => result.data.riskRelevanceByLegalEntityIdAndCampaignId));
  }

  createRiskMap(props: {
    legalEntityId: string,
    campaignId: string,
    cptId: string[],
    parameterId: string,
    value: boolean
  }): Observable<CreateRiskMapMutation['createRiskMap']> {
    return this.CreateRiskMapGQL.mutate(
      //TODO quando il backend cambierà i servizi, togliere [0] da cptId
      { legalEntityId: props.legalEntityId, campaignId: props.campaignId, cptId: props.cptId[0], parameterId: (props.parameterId === '0' ? '1' : props.parameterId), value: props.value }, {
      fetchPolicy: 'no-cache'
    }).pipe(map(result => result.data?.createRiskMap));
  }

  createRiskMapByNodes(props: {
    legalEntityId: string,
    campaignId: string,
    cptId: string[],
    parameterId: string,
    value: boolean
  }): Observable<CreateRiskMapByCptsMutation['createRiskMapNodeByCpts']> {
    return this.CreateRiskMapByCptsGQL.mutate(
      // {
      //   legalEntityId: props.legalEntityId,
      //   campaignId: props.campaignId,
      //   parameters: props.cptId.map(cpt => ({ cptIds: [cpt], parameterId: props.parameterId })),
      //   value: props.value
      // }, 
      {
        legalEntityId: props.legalEntityId,
        campaignId: props.campaignId,
        parameters: { cptIds: props.cptId, parameterId: props.parameterId },
        value: props.value
      },
      {
        fetchPolicy: 'no-cache'
      }).pipe(map(result => result.data?.createRiskMapNodeByCpts));
  }

  updateRiskmapByIds(riskMapIds: string[], value: boolean): Observable<UpdateRiskMapByIdsMutation['updateRiskMapByIds']> {
    return this.UpdateRiskMapByIdsGQL.mutate(
      {
        riskMapIds,
        value
      }, {
      fetchPolicy: 'no-cache'
    }).pipe(map(result => result.data?.updateRiskMapByIds));
  }

  updateRiskMapStatus(cptIds: string[], legalEntityId: string, riskMapStatus: RiskMapStatusEnum): Observable<UpdateRiskMapStatusMutation['updateRiskMapStatusByCptIdsAndLegalEntityId']> {
    return this.UpdateRiskMapStatusGQL.mutate(
      {
        cptIds,
        legalEntityId,
        riskMapStatus
      }, {
      fetchPolicy: 'no-cache'
    }).pipe(map(result => result.data?.updateRiskMapStatusByCptIdsAndLegalEntityId));
  }


  updateRiskEvaluation(
    riskMapId: string,
    impactId: string | null,
    controlSystemId: string,
    likelihoodId: string
  ): Observable<UpdateEvaluationRiskMutation['updateRiskMapRiskEvaluationByRiskMapId']> {
    return this.UpdateEvaluationRiskGQL.mutate(
      {
        riskMapId,
        update: { controlSystemId, likelihoodId, impactId }
      }, {
      fetchPolicy: 'no-cache'
    }).pipe(map(result => result.data?.updateRiskMapRiskEvaluationByRiskMapId));
  }

  getRiskMapFilterNames(): Observable<QueryriskMapRiskViewByCampaignIdAndRiskIdQuery['riskMapRiskViewByCampaignIdAndRiskId']> {
    return of([] as QueryriskMapRiskViewByCampaignIdAndRiskIdQuery['riskMapRiskViewByCampaignIdAndRiskId'])
  }


  updateAU(
    legalEntityId: string,
    campaignId: string,
    cptId: string,
    value: boolean,
    level: string,
    processCode: string
  ): Observable<SetAuMutation['updateAuditableUniverse'] | undefined> {
    return this.SetAuGQL.mutate({
      campaignId,
      cptId,
      legalEntityId,
      level,
      value,
      processCode
    }, {
      fetchPolicy: 'no-cache'
    }).pipe(map(result => result.data?.updateAuditableUniverse));
  }

  updateProcessNote(
    legalEntityId: string,
    campaignId: string,
    processCode: string,
    note: string
  ): Observable<UpdateProcessNoteMutation['updateProcessNote'] | undefined> {
    return this.UpdateProcessNoteGQL.mutate({
      legalEntityId,
      campaignId,
      processCode,
      processNote: note
    }, {
      fetchPolicy: 'no-cache'
    }).pipe(map(result => result.data?.updateProcessNote));
  }
}

export function convertLazyLoadToComplexWithoutPage(parameters: any): QueryLegalEntitiesByQueryComplexArgs {
  const query: LegalEntitySimpleQueryInput[] = [];
  if (parameters) {

    if (parameters.filters) {

      Object.entries(parameters.filters).forEach(([field, values]) => {
        //console.log"value", values);

        if (values !== null && Array.isArray(values) && values.length > 0) {
          (ENUM_CPT[field as keyof typeof ENUM_CPT] || [field]).forEach(key => {
            query.push({
              field: key as LegalEntityFields,
              filters: {
                operator: ComparatorOperators.Match,
                value: values
              }
            });
          })
        }
      });
    }
  }
  return {
    query: {
      operator: OperatorInput.And,
      query: [
        {
          query: query,
          operator: OperatorInput.And
        }
      ]
    },
    sort: {
      sortField: ENUM_CPT?.[parameters?.order?.sortField as keyof typeof ENUM_CPT]?.[0] as LegalEntityFields || null,
      sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
    }
  }
}

export const ENUM_CPT = {
  name: ['LEVEL_ONE_PROCESS_NAME', 'LEVEL_TWO_PROCESS_NAME', 'LEVEL_THREE_PROCESS_NAME'],
  code: ['LEVEL_ONE_PROCESS_CODE', 'LEVEL_TWO_PROCESS_CODE', 'LEVEL_THREE_PROCESS_CODE'],
  levelTwoProcessName: ['LEVEL_ONE_PROCESS_NAME', 'LEVEL_TWO_PROCESS_NAME', 'LEVEL_THREE_PROCESS_NAME'],
  levelTwoProcessCode: ['LEVEL_ONE_PROCESS_CODE', 'LEVEL_TWO_PROCESS_CODE', 'LEVEL_THREE_PROCESS_CODE'],
  cluster: ['LEVEL_ONE_CLUSTER', 'LEVEL_TWO_CLUSTER', 'LEVEL_THREE_CLUSTER'],
  note: ['LEVEL_ONE_NOTE', 'LEVEL_TWO_NOTE', 'LEVEL_THREE_NOTE']
}